import React from 'react';
import T from 'prop-types';

import getLocale from 'utils/getLocale';
import { Head, withRouteData } from 'react-static';
import SignUp from 'components/SignUp';
import getLocalizationLink from '../utils/getLocalizationLink';
import getMetaData from '../utils/getMetaData';

const host = process.env.SITE_HOST;

const metaData = {
  title: {
    en: 'Create a free account | Liquid.com',
  },
  description: {
    en:
      'Beginners easily buy and sell crypto. Traders leverage a powerful trading platform for crypto and fiat currencies with great liquidity. Be Liquid, my friends',
  },
};

const PageSignUp = ({ language, path }) => {
  return (
    <React.Fragment>
      <Head>
        <title>{getMetaData(metaData, 'title', language)}</title>
        <meta
          name="description"
          content={getMetaData(metaData, 'description', language)}
        />
        <meta name="author" content="Liquid Global" />
        <meta name="robots" content="all" />

        {/* Facebook */}
        <meta property="og:locale" content={getLocale(language)} />
        <meta
          property="og:title"
          content={getMetaData(metaData, 'title', language)}
        />
        <meta
          property="og:description"
          content={getMetaData(metaData, 'description', language)}
        />
        <meta
          property="og:site_name"
          content={getMetaData(metaData, 'title', language)}
        />
        <meta property="og:image" content={`${host}/liquid-sign-up.jpg`} />
        <meta
          property="og:url"
          content={`${host}${getLocalizationLink(language, path)}`}
        />
        <meta property="og:type" content="website" />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="315" />

        {/* Twitter */}
        <meta
          name="twitter:description"
          content={getMetaData(metaData, 'description', language)}
        />
        <meta
          name="twitter:title"
          content={getMetaData(metaData, 'title', language)}
        />
        <meta name="twitter:image" content={`${host}/liquid-sign-up.jpg`} />
        <meta
          name="twitter:url"
          content={`${host}${getLocalizationLink(language, path)}`}
        />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@Liquid_Global" />
        <meta name="twitter:creator" content="@Liquid_Global" />
      </Head>
      <SignUp />
    </React.Fragment>
  );
};

PageSignUp.propTypes = {
  language: T.string.isRequired,
  path: T.string.isRequired,
};

export default withRouteData(PageSignUp);



// WEBPACK FOOTER //
// ../src/pages/Signup.jsx